import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    buttonText: {
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
      justifyContent: 'inherit',
    },
  };
};
